import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/keen-slider/keen-slider.min.css");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/nextjs-toploader/dist/index.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/slick-carousel/slick/slick.css");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/slick-carousel/slick/slick-theme.css");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/views/MainView.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.css")